export function getAthleteFlag(eps: number, engineScore: number, ignitionScore: number, bounceScore: number): 'green' | 'yellow' | 'red' {
  const minScore = Math.min(engineScore, ignitionScore, bounceScore);
  if (eps >= 80 && minScore >= 70) return 'green';
  if (eps < 65 || minScore < 55) return 'red';
  return 'yellow';
}

export function getWeakestCategory(engineScore: number, ignitionScore: number, bounceScore: number): string {
  const min = Math.min(engineScore, ignitionScore, bounceScore);
  if (min === engineScore) return 'Engine';
  if (min === ignitionScore) return 'Ignition';
  return 'Bounce';
}
